"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReasonCode = exports.convertToCamelCase = exports.mapB2bPoeDetails = exports.getB2BadditionalDetails = exports.docComplete = exports.getDealersOfferContent = exports.isLinePlanSkuAvailable = exports.isBillEstimatorApplicable = exports.IsNewWirelessInCart = exports.isBillPrefPanelInProgress = exports.isSMBNewWLSFlow = exports.isNewWLSFlow = exports.getRetailOfferPortinData = exports.cartACPEligibility = exports.getDueMonthlyValue = exports.isDealerOffersAvailable = exports.isACPAccessPromoAvailable = exports.isACPFlowWithBroadBand = exports.getCurrentURL = exports.checkStatusCodeFromSession = exports.getUrlParameter = exports.getHardStopText = exports.isPrepreOrder = exports.GET_SVG_ICON = exports.isGNGDesignEnabled = exports.isAuthAccountPanelNotDone = exports.getInsTargetStates = exports.getSubscriberNumber = exports.isDesktopAuthFlowNoSelectedShip = exports.getAddrValidationRec = exports.getValidationRecIndex = exports.billingAddrForShippingValidation = exports.getAvpsValidationType = exports.billingAddrForShippingCopy = exports.getMobileAlertOptValue = exports.isCbrConsentOpted = exports.getSelectDefaultValue = exports.handleSelectEvents = exports.createSelectOptions = exports.removeSpecialChars = exports.setFocusOnDocumentElement = exports.getChatDetails = exports.getDateTimeFormat = exports.ordinal_suffix_of = exports.shouldSPIEncryptionEnabled = exports.encryptMessage = exports.getSubStringOfWord = exports.calculateNextOpenDay = exports.getDayString = exports.capitalize = exports.checkIfInstantonProd = exports.formatDateWhileOnChange = exports.getMMYYFormatDate = exports.checkIfProd = exports.isEmptyObject = exports.isKeyExist = exports.isEmpty = exports.convertYYtoYYYYInDate = exports.getFormatedDate = exports.formatSocialSecurityNumber = exports.formatTaxNumber = exports.isInValidName = void 0;
var EndPointsConfig_1 = require("../api/EndPointsConfig");
var StateProvider_1 = require("../api/StateProvider");
var localdatastore_1 = require("../config/localdatastore");
var date_fns_timezone_1 = require("date-fns-timezone");
var date_fns_1 = require("date-fns");
var Utils = require("./UtilityFunctions");
var AddressService_1 = require("./AddressService");
var cms_integration_1 = require("@idp/cms-integration");
var Checkout_cms_1 = require("../cms/Checkout.cms");
var CheckoutConstants_1 = require("./CheckoutConstants");
var DealerOffers_cms_1 = require("../components/panels/DeviceOptionsPanel/DeviceCard/DealerOffers.cms");
var NUM_ONLY_REGEX = new RegExp('^[0-9]*$');
function isInValidName(value) {
    return (!value || !(new RegExp('^[a-zA-Z]*$')).test(value.charAt(0)) ||
        !(new RegExp('^[a-zA-Z\\s]*$')).test(value));
}
exports.isInValidName = isInValidName;
function formatTaxNumber(formatSSN) {
    if (formatSSN && (formatSSN.length > 2)) {
        return formatSSN.replace(/(\d{2})(\d*)/, '$1' + '-' + '$2');
    }
    else {
        return formatSSN;
    }
}
exports.formatTaxNumber = formatTaxNumber;
function formatSocialSecurityNumber(formatSSN) {
    if (formatSSN && (formatSSN.length > 3 && formatSSN.length < 6)) {
        return formatSSN.replace(/(\d{3})(\d*)/, '$1' + '-' + '$2');
    }
    else if (formatSSN && (formatSSN.length > 5 && formatSSN.length < 10)) {
        return formatSSN.replace(/(\d{3})(\d{2})(\d*)/, '$1' + '-' + '$2' + '-' + '$3');
    }
    else {
        return formatSSN;
    }
}
exports.formatSocialSecurityNumber = formatSocialSecurityNumber;
function getFormatedDate(value, isfullMonth, omitYear) {
    var regPattern = /(\d{4})\-(\d{2})\-(\d{2})$/;
    if (value && regPattern.test(value)) {
        return value.replace(regPattern, function (match, p1, p2, p3) {
            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var fullmonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
                'October', 'November', 'December'];
            if (isfullMonth) {
                return fullmonths[(p2 - 1)] + " " + p3 + ", " + p1;
            }
            else if (omitYear) {
                return months[(p2 - 1)] + " " + p3;
            }
            else {
                return months[(p2 - 1)] + " " + p3 + ", " + p1;
            }
        });
    }
    else {
        return value;
    }
}
exports.getFormatedDate = getFormatedDate;
function convertYYtoYYYYInDate(value) {
    if (value && value.length === 2 && NUM_ONLY_REGEX.test(value)) {
        return ((new Date().getFullYear()).toString()).substring(0, 2) + value;
    }
    else {
        return value;
    }
}
exports.convertYYtoYYYYInDate = convertYYtoYYYYInDate;
function isEmpty(value) {
    return (value === null || typeof value === 'undefined' || (value === ''));
}
exports.isEmpty = isEmpty;
// tslint:disable-next-line:no-any
function isKeyExist(obj, key) {
    if (isEmpty(key)) {
        return false;
    }
    return key.split('.').every(function (s) {
        if (isEmptyObject(obj) || !obj.hasOwnProperty(s)) {
            return false;
        }
        obj = obj[s];
        return true;
    });
}
exports.isKeyExist = isKeyExist;
function isEmptyObject(obj) {
    return (obj === null
        || typeof obj === 'undefined'
        || typeof obj !== 'object'
        || (Object.keys(obj).length === 0));
}
exports.isEmptyObject = isEmptyObject;
function checkIfProd() {
    var isProd = true;
    var hostname = window && window.location.hostname && window.location.hostname.replace('www.', '');
    if (hostname !== 'att.com') {
        isProd = false;
    }
    return isProd;
}
exports.checkIfProd = checkIfProd;
function getMMYYFormatDate(value) {
    if (value && value.length > 0) {
        return value.replace(/^([1-9]\/|[2-9])$/g, '0$1/').replace(/^(0[1-9]|1[0-2])$/g, '$1/').replace(/^([0-1])([3-9])$/g, '0$1/$2').replace(/^(0?[1-9]|1[0-2])([0-9]{2}|[0-9]{4})$/g, '$1/$2').replace(/^([0]+)\/|[0]+$/g, '0').replace(/[^\d\/]|^[\/]*$/g, '').replace(/\/\//g, '/');
    }
    else {
        return value;
    }
}
exports.getMMYYFormatDate = getMMYYFormatDate;
function formatDateWhileOnChange(formatDate) {
    var numRegex = new RegExp('^[0-9]*$');
    if (formatDate
        && (formatDate.length === 2
            || formatDate.length === 5)) {
        return formatDate + '/';
    }
    else if (formatDate
        && formatDate.length === 8
        && numRegex.test(formatDate)) {
        var tempDate = formatDate;
        var tempResult = tempDate.substring(0, 2) + '/' + tempDate.substring(2, 4) + '/' + tempDate.substring(4, 8);
        return DOBDatesCheck(tempResult);
    }
    else if (formatDate
        && formatDate.length === 10
        && (formatDate.indexOf('/') !== 2
            || !numRegex.test(formatDate.substring(0, 2))
            || !numRegex.test(formatDate.substring(3, 5))
            || !numRegex.test(formatDate.substring(6, 10))
            || formatDate.substring(3, 10).indexOf('/') !== 2)) {
        return '';
    }
    else {
        return DOBDatesCheck(formatDate);
    }
}
exports.formatDateWhileOnChange = formatDateWhileOnChange;
function checkSingleNum(num) {
    return num < 10 ? '0' + num.toString() : num.toString();
}
function DOBDatesCheck(value) {
    if (value.length >= 10) {
        var month = parseInt(value.substring(0, 2), 10);
        var day = parseInt(value.substring(3, 5), 10);
        var year = parseInt(value.substring(6, 10), 10);
        var currentYear = new Date().getFullYear();
        month = parseInt(value.substring(0, 2), 10);
        if (month < 1) {
            month = 1;
        }
        else if (month > 12) {
            month = 12;
        }
        value = value.replace(value.substring(0, 2), checkSingleNum(month));
        if (year < 1900) {
            year = 1900;
        }
        else if (year > currentYear) {
            year = year;
        }
        value = value.replace(value.substring(6, 10), year.toString());
        var daysOfTargetMonth = new Date(year, month, 0).getDate();
        if (day < 1) {
            day = 1;
        }
        else if (day > daysOfTargetMonth) {
            day = daysOfTargetMonth;
        }
        value = value.replace(value.substring(3, 5), checkSingleNum(day));
        return value;
    }
    else {
        return value;
    }
}
function checkIfInstantonProd() {
    var hostname = window && window.location && window.location.hostname;
    // Adding dev2 case to verify the changes, will be removed later
    return (hostname === 'instanton.att.com' || hostname === 'idse2.dev.att.com');
}
exports.checkIfInstantonProd = checkIfInstantonProd;
function capitalize(word) {
    return word === null || word === void 0 ? void 0 : word.toLowerCase().replace(/\b(\w)/g, function (x) { return x.toUpperCase(); });
}
exports.capitalize = capitalize;
exports.getDayString = function (day) {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day];
};
exports.calculateNextOpenDay = function (selectedStore) {
    var _a;
    var today = new Date(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.localTime).getDay() || new Date().getDay();
    var availableDayList = ((_a = selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.hours) === null || _a === void 0 ? void 0 : _a.split(',').map(function (day) { return day.split(' ')[0]; })) || [];
    for (var i = 1; i < 7; i++) {
        /* istanbul ignore next */
        if (availableDayList.includes(exports.getDayString((today + i) % 7))) {
            if (i === 1) {
                return 'tomorrow';
            }
            var index = availableDayList.indexOf(exports.getDayString(today + i));
            return "on " + availableDayList[index];
        }
    }
    return null;
};
function getSubStringOfWord(inString, firstWord, lastWord) {
    if (inString && inString.length > 0 && firstWord && inString.indexOf(firstWord) > -1 &&
        lastWord && inString.indexOf(lastWord) > -1) {
        return inString.substring(inString.lastIndexOf(firstWord) + firstWord.length, inString.lastIndexOf(lastWord));
    }
    else if (inString && inString.length > 0 && firstWord && inString.indexOf(firstWord) > -1) {
        return inString.substring(inString.lastIndexOf(firstWord) + firstWord.length);
    }
    else if (inString && inString.length > 0 && lastWord && inString.indexOf(lastWord) > -1) {
        return inString.substring(inString.lastIndexOf(lastWord) + lastWord.length);
    }
    else {
        return '';
    }
}
exports.getSubStringOfWord = getSubStringOfWord;
function encryptMessage(message) {
    var JSEncrypt = require('jsencrypt');
    var encryptor = new JSEncrypt();
    encryptor.setPublicKey(EndPointsConfig_1.default.pubKey);
    return encryptor.encrypt(message);
}
exports.encryptMessage = encryptMessage;
function shouldSPIEncryptionEnabled() {
    var isSPIEncryptionEnabled = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isSPIEncryptionEnabled');
    return (isSPIEncryptionEnabled === null || isSPIEncryptionEnabled === void 0 ? void 0 : isSPIEncryptionEnabled.isSPIEncryptionEnabled);
}
exports.shouldSPIEncryptionEnabled = shouldSPIEncryptionEnabled;
function ordinal_suffix_of(i) {
    var j = i % 10;
    var k = i % 100;
    if (j === 1 && k !== 11) {
        return i + 'st';
    }
    if (j === 2 && k !== 12) {
        return i + 'nd';
    }
    if (j === 3 && k !== 13) {
        return i + 'rd';
    }
    return i + 'th';
}
exports.ordinal_suffix_of = ordinal_suffix_of;
function getDateTimeFormat(time, dayFormat, timeFormat, timeZone, formatDateToTimezone) {
    // formatDateToTimeZone - 'True' provided to convert date to requested timezone; 'False' format provided date
    var formatDay = '';
    var formatTime = '';
    if (formatDateToTimezone) {
        formatDay = date_fns_timezone_1.formatToTimeZone(new Date(time), dayFormat, { timeZone: timeZone });
        formatTime = date_fns_timezone_1.formatToTimeZone(new Date(time), timeFormat, { timeZone: timeZone });
    }
    else {
        formatDay = date_fns_1.format(new Date(time), dayFormat);
        formatTime = date_fns_1.format(new Date(time), timeFormat);
    }
    return { formatDay: formatDay, formatTime: formatTime };
}
exports.getDateTimeFormat = getDateTimeFormat;
function getChatDetails(ANDiChatFlag) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var activeChatData, aid, id, err_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    if (!(ANDiChatFlag && (window === null || window === void 0 ? void 0 : window.getANDiChatAgent))) return [3 /*break*/, 2];
                    return [4 /*yield*/, ((_a = window === null || window === void 0 ? void 0 : window.getANDiChatAgent()) === null || _a === void 0 ? void 0 : _a.then(function (chatObj) {
                            var id = chatObj === null || chatObj === void 0 ? void 0 : chatObj.chatId;
                            var aid = chatObj === null || chatObj === void 0 ? void 0 : chatObj.agentId;
                            return { aid: aid, id: id };
                        }).catch(function (err) {
                            console.log('<<< getANDiChatAgent err >>> ', err);
                            return null;
                        }))];
                case 1: 
                // tslint:disable-next-line: no-any
                return [2 /*return*/, _d.sent()];
                case 2:
                    if (window === null || window === void 0 ? void 0 : window.Inq) {
                        activeChatData = (_c = (_b = window === null || window === void 0 ? void 0 : window.Inq) === null || _b === void 0 ? void 0 : _b.getData()) === null || _c === void 0 ? void 0 : _c.CHM;
                        aid = activeChatData === null || activeChatData === void 0 ? void 0 : activeChatData.aid;
                        id = activeChatData === null || activeChatData === void 0 ? void 0 : activeChatData.id;
                        return [2 /*return*/, { aid: aid, id: id }];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_1 = _d.sent();
                    console.log('<<< getChatDetails >>> ', err_1);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.getChatDetails = getChatDetails;
function setFocusOnDocumentElement(selElement) {
    /* istanbul ignore next */ // Disabling coverage since its working with dom manipulation
    setTimeout(function () {
        var errMsg = document.querySelectorAll(selElement)[0];
        errMsg.focus();
        errMsg.scrollIntoView();
    });
}
exports.setFocusOnDocumentElement = setFocusOnDocumentElement;
function removeSpecialChars(value) {
    if (value) {
        return value.replace(/[^a-zA-Z0-9]/g, '');
    }
    else {
        return value;
    }
}
exports.removeSpecialChars = removeSpecialChars;
exports.createSelectOptions = function (choices) { return choices.map(function (choice) {
    return { value: choice.displayText };
}); };
exports.handleSelectEvents = function (fn, choiceMap, placeHolder) { return function (e) {
    var placeHolderValue = { value: placeHolder };
    return e.selected === -1 ? fn(placeHolderValue) : fn(choiceMap[e.selected]);
}; };
exports.getSelectDefaultValue = function (choiceMap, text) { return choiceMap.findIndex(function (choice) {
    return choice.displayText === text;
}); };
function isCbrConsentOpted() {
    var cbrConsentInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'cbrConsentOptedInAccessIdPanel');
    return !!(cbrConsentInfo === null || cbrConsentInfo === void 0 ? void 0 : cbrConsentInfo.cbrConsentOpted);
}
exports.isCbrConsentOpted = isCbrConsentOpted;
function getMobileAlertOptValue() {
    var cbrConsentData = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'cbrConsentOptedInAccessIdPanel');
    return !!(cbrConsentData === null || cbrConsentData === void 0 ? void 0 : cbrConsentData.mobileAlertOpted);
}
exports.getMobileAlertOptValue = getMobileAlertOptValue;
function billingAddrForShippingCopy(payloadContent) {
    // Temporary IsBsseFlow() condition, could be removed once address validation is implemented for all LOBs
    var validationType = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.avpsTypeValidationRecommendation;
    if (Utils.IsBsseFlow()) {
        if (validationType.shipping === AddressService_1.AddressErrorTypes.STOP) {
            StateProvider_1.StateProvider.getStateManagerInstance().set('validationAddressError', { reasonCode: AddressService_1.AddressErrorTypes.STOP, update: false });
        }
        else if (validationType.shipping === AddressService_1.AddressErrorTypes.WARN) {
            var errorCode = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.validationReasonCode;
            StateProvider_1.StateProvider.getStateManagerInstance().set('shippingAddrValidationError', { shippingError: true, errorCode: errorCode });
        }
        else {
            sessionStorage.removeItem('CHECKOUT:validationAddressError');
            sessionStorage.removeItem('CHECKOUT:shippingAddrValidationError');
        }
    }
}
exports.billingAddrForShippingCopy = billingAddrForShippingCopy;
function getAvpsValidationType(payloadContent, addressType) {
    var validationType = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.avpsTypeValidationRecommendation;
    if (addressType === 'billing') {
        billingAddrForShippingCopy(payloadContent);
        return validationType.billing;
    }
    else if (addressType === 'shipping' || addressType === 'delivery') {
        return validationType.shipping;
    }
    else if (addressType === 'ppuAddress') {
        return validationType.ppu;
    }
    return null;
}
exports.getAvpsValidationType = getAvpsValidationType;
function billingAddrForShippingValidation(payloadContent, shippingType) {
    var _a, _b, _c, _d;
    // Temporary IsBsseFlow() condition, could be removed once address validation is implemented for all LOBs
    var validationTypeRec = (_a = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _a === void 0 ? void 0 : _a.validationTypeRec;
    if (Utils.IsBsseFlow() && Utils.IsWirelessInCart()) {
        var index = validationTypeRec.findIndex(function (type) { return type.validationType === shippingType; });
        var recommendation = (_b = validationTypeRec[index]) === null || _b === void 0 ? void 0 : _b.validationRecommendation;
        if (recommendation === AddressService_1.AddressErrorTypes.STOP) {
            StateProvider_1.StateProvider.getStateManagerInstance().set('validationAddressError', { reasonCode: recommendation, update: false });
        }
        else if (recommendation === AddressService_1.AddressErrorTypes.WARN) {
            var errorCode = (_d = (_c = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _c === void 0 ? void 0 : _c.status) === null || _d === void 0 ? void 0 : _d.code;
            StateProvider_1.StateProvider.getStateManagerInstance().set('shippingAddrValidationError', { shippingError: true, errorCode: errorCode });
        }
        else {
            sessionStorage.removeItem('CHECKOUT:validationAddressError');
            sessionStorage.removeItem('CHECKOUT:shippingAddrValidationError');
        }
    }
}
exports.billingAddrForShippingValidation = billingAddrForShippingValidation;
function getValidationRecIndex(payloadContent, addressType) {
    var _a;
    var validationTypeRec = (_a = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _a === void 0 ? void 0 : _a.validationTypeRec;
    var billingType;
    var shippingType;
    var ppuType;
    if (Utils.IsBsseFlow() && Utils.IsWirelessInCart()) {
        billingType = 'BILLING_LOOSE';
        shippingType = 'SHIPPING_STRICT';
        ppuType = 'PPU_STRICT';
    }
    else if (Utils.IsDTVNOWInCart() || Utils.IsBBTVInCart || Utils.IsBroadbandInCart()) {
        billingType = 'BILLING_LOOSE';
        shippingType = 'SHIPPING_LOOSE';
        ppuType = 'PPU_STRICT';
    }
    else {
        billingType = 'BILLING_STRICT';
        shippingType = 'SHIPPING_STRICT';
        ppuType = 'PPU_STRICT';
    }
    if (addressType === 'billing') {
        billingAddrForShippingValidation(payloadContent, shippingType);
        return validationTypeRec.findIndex(function (type) { return type.validationType === billingType; });
    }
    else if (addressType === 'shipping' || addressType === 'delivery') {
        return validationTypeRec.findIndex(function (type) { return type.validationType === shippingType; });
    }
    else if (addressType === 'ppuAddress') {
        return validationTypeRec.findIndex(function (type) { return type.validationType === ppuType; });
    }
    return null;
}
exports.getValidationRecIndex = getValidationRecIndex;
function getAddrValidationRec(payloadContent, addressType) {
    var _a, _b;
    // Temporary IsBsseFlow() condition, could be removed once address validation is implemented for all LOBs
    if (Utils.IsBsseFlow() && isKeyExist(payloadContent, 'avpsTypeValidationRecommendation')) {
        var avpsValidType = getAvpsValidationType(payloadContent, addressType);
        return avpsValidType;
    }
    else if (Utils.IsBsseFlow() && isKeyExist(payloadContent.hostResponse, 'validationTypeRec')) {
        var indexOfValidationType = getValidationRecIndex(payloadContent, addressType);
        return (_b = (_a = payloadContent === null || payloadContent === void 0 ? void 0 : payloadContent.hostResponse) === null || _a === void 0 ? void 0 : _a.validationTypeRec[indexOfValidationType]) === null || _b === void 0 ? void 0 : _b.validationRecommendation;
    }
    return null;
}
exports.getAddrValidationRec = getAddrValidationRec;
function isDesktopAuthFlowNoSelectedShip() {
    var shippingMethodSelected = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'FulFillmethodOpted');
    return (Utils.isUPOrAALFlow() && !Utils.isMobile() && !Utils.isMyATTApp() && !(shippingMethodSelected === null || shippingMethodSelected === void 0 ? void 0 : shippingMethodSelected.type));
}
exports.isDesktopAuthFlowNoSelectedShip = isDesktopAuthFlowNoSelectedShip;
function getSubscriberNumber() {
    var _a, _b, _c, _d;
    var payload = Utils.getCartResp();
    var ctnNumber;
    if (((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) || ((_b = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _b === void 0 ? void 0 : _b.losgs)) {
        var logsList = ((_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c.losgs) || ((_d = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _d === void 0 ? void 0 : _d.losgs);
        Object.values(logsList).forEach(function (losg) {
            var _a;
            if (((_a = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _a === void 0 ? void 0 : _a.associatedCtn) && (losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'UP') {
                ctnNumber = losg.extraParams.associatedCtn;
            }
        });
    }
    return ctnNumber;
}
exports.getSubscriberNumber = getSubscriberNumber;
function getInsTargetStates() {
    var targetStates = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'InsTargetStates');
    return targetStates && targetStates.states;
}
exports.getInsTargetStates = getInsTargetStates;
function isAuthAccountPanelNotDone() {
    var isPanelDone = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isAccountPanelDone');
    return (Utils.isUPOrAALFlow() && !(isPanelDone === null || isPanelDone === void 0 ? void 0 : isPanelDone.isCompleted));
}
exports.isAuthAccountPanelNotDone = isAuthAccountPanelNotDone;
function isGNGDesignEnabled() {
    var gngDesignEnabled = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'showLastMileStoresDesign');
    return !!(gngDesignEnabled && gngDesignEnabled.display);
}
exports.isGNGDesignEnabled = isGNGDesignEnabled;
var GET_SVG_ICON;
(function (GET_SVG_ICON) {
    GET_SVG_ICON["RETAILSTORE"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"><path class=\"svg-accent-att-blue\" d=\"M75 67H50V51h25zm-23-2h21V53H52z\" fill=\"#009FDB\"/><path class=\"svg-base\" d=\"M87 27h-3.51l-3.26-12H15.77l-3.26 12H9v8h3v40a6 6 0 006 6h60a6 6 0 006-6V35h3zM17.3 17h61.4l2.72 10H14.58zM23 79V60.5a7.5 7.5 0 0115 0V79zm55 0H40V60.5a9.5 9.5 0 00-19 0V79h-3a4 4 0 01-4-4V39.89a9.72 9.72 0 0016.5-1.62 9.73 9.73 0 0017.5 0 9.73 9.73 0 0017.5 0A9.72 9.72 0 0082 39.89V75a4 4 0 01-4 4zM14.07 35h15.36a7.74 7.74 0 01-15.36 0zm17.5 0h15.36a7.74 7.74 0 01-15.36 0zm17.5 0h15.36a7.74 7.74 0 01-15.36 0zm17.5 0h15.36a7.74 7.74 0 01-15.36 0zM85 33H11v-4h74z\"/></svg>";
    GET_SVG_ICON["PERSONALDELIVERY"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"60px\" width=\"60px\" viewBox=\"0 0 96 96\"><path class=\"svg-accent-att-blue\" d=\"M68 43H51v12h17zm-2 10H53v-8h13z\" fill=\"#009FDB\"/><path class=\"svg-base\" d=\"M87 60.69a7 7 0 00-9.83-1.2L73 62.74V31h6V14H17v17h6v29.08A17.4 17.4 0 0015.39 67H8v2h7v12H8v2h57.34a13 13 0 008-2.76l12.43-9.73A7 7 0 0087 60.69zM19 16h58v13H19zm6 15h46v33.3l-3 2.36A11.06 11.06 0 0161.21 69h-2.75A6 6 0 0060 65v-7H32.82A23.45 23.45 0 0025 59.26zm61.43 34.61a5 5 0 01-1.88 3.33l-12.43 9.72A11 11 0 0165.34 81H17V68.23c.6-1.15 4.71-8.23 15.82-8.23H58v5a4 4 0 01-4 4H40v2h21.21a13.07 13.07 0 008-2.76l9.17-7.18a5 5 0 018 4.55z\"/></svg>";
    GET_SVG_ICON["DEVICES2ICON"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"60px\" width=\"60px\" viewBox=\"0 0 96 96\"><path class=\"svg-base\" d=\"M14 64h45v2H8v4a4 4 0 004 4h47v2H12a6 6 0 01-6-6v-6h6V26a6 6 0 016-6h60a6 6 0 016 6v10h-2V26a4 4 0 00-4-4H18a4 4 0 00-4 4zm75.92 15.77V44.23A4.24 4.24 0 0085.68 40H66.3a4.24 4.24 0 00-4.23 4.23v35.54A4.24 4.24 0 0066.3 84h19.38a4.24 4.24 0 004.24-4.23zM85.68 42a2.24 2.24 0 012.24 2.23v35.54A2.24 2.24 0 0185.68 82H66.3a2.23 2.23 0 01-2.23-2.23V44.23A2.23 2.23 0 0166.3 42z\"/><path class=\"svg-accent-att-blue\" d=\"M42 71v-2h12v2zm38.3-25.62h-8.62v2h8.62z\" fill=\"#009FDB\"/></svg>";
    GET_SVG_ICON["FastDelivery"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M28.982 14.87l-4.818-1.604-3.294-2.786a10.223 10.223 0 00-6.589-2.417H8.17a2.828 2.828 0 00-2.649 1.91q-.127.374-.246.756l1.771.547c.074-.238.152-.475.227-.697a.956.956 0 01.897-.662h6.111a8.366 8.366 0 015.391 1.978l3.43 2.902a.929.929 0 00.307.172l4.98 1.657a.94.94 0 01.644.885v1.678a.931.931 0 01-.275.667.946.946 0 01-.652.26h-.132a3.69 3.69 0 00-7.152-.008l-6.706-.068a3.688 3.688 0 00-7.13.076h-.124a.93.93 0 01-.936-.908v-1.206H4.072v1.206a2.791 2.791 0 002.782 2.763h.131a3.694 3.694 0 007.178-.075l6.654.067a3.691 3.691 0 007.157.008h.149a2.736 2.736 0 001.94-.799 2.77 2.77 0 00.824-1.983v-1.678a2.797 2.797 0 00-1.905-2.642zm-18.42 8.027a1.854 1.854 0 111.854-1.854 1.856 1.856 0 01-1.854 1.854zm13.835 0a1.854 1.854 0 111.854-1.854 1.856 1.856 0 01-1.854 1.854zM9.175 14.002H2v-2h7.176zm-3 3H1v-2h5.176z\"/></svg>";
})(GET_SVG_ICON = exports.GET_SVG_ICON || (exports.GET_SVG_ICON = {}));
function isPrepreOrder(cartResponse) {
    var _a;
    if (cartResponse && cartResponse.content && cartResponse.content.payload &&
        cartResponse.content.payload.wirelessCart && cartResponse.content.payload.wirelessCart.losgs &&
        cartResponse.content.payload.wirelessCart.losgs) {
        var logsList = (_a = cartResponse.content.payload.wirelessCart.losgs['losg-wls-al-001']) === null || _a === void 0 ? void 0 : _a.lineItems;
        for (var item in logsList) {
            if (logsList[item].itemType.toLowerCase() === 'device' && logsList[item].prePreOrderIndicator === true) {
                return true;
            }
        }
    }
    return false;
}
exports.isPrepreOrder = isPrepreOrder;
function getHardStopText(hardstopText, tollFreeNumber) {
    var _a, _b, _c, _d;
    // tslint:disable-next-line:no-any
    var wlsPostpaidInfo = JSON.parse(sessionStorage.getItem('wlsPostpaid'));
    var isFirstNetUser = ((_a = wlsPostpaidInfo === null || wlsPostpaidInfo === void 0 ? void 0 : wlsPostpaidInfo.wirelessResponseAl) === null || _a === void 0 ? void 0 : _a.isFirstNet) || ((_b = wlsPostpaidInfo === null || wlsPostpaidInfo === void 0 ? void 0 : wlsPostpaidInfo.wirelessResponse) === null || _b === void 0 ? void 0 : _b.isFirstNet) || Utils.isFirstNetFlow();
    var cmsData = (_c = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'CheckoutCms').content) === null || _c === void 0 ? void 0 : _c.checkoutCTOModal;
    var onlineCMS = (_d = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content) === null || _d === void 0 ? void 0 : _d.checkoutCTOModal;
    var fnHardStopText;
    var isFirstNetCaribbeanUser = Utils.isFirstNetCaribbean();
    if (isFirstNetUser) {
        if (isFirstNetCaribbeanUser) {
            fnHardStopText = (onlineCMS === null || onlineCMS === void 0 ? void 0 : onlineCMS.fnCaribbeanBodyLabel) || "Call FirstNet Support at <a href='tel:800.574.7000'>800.574.7000</a> for help with your order.";
            return fnHardStopText;
        }
        fnHardStopText = (onlineCMS === null || onlineCMS === void 0 ? void 0 : onlineCMS.fnBodyLabel) || (cmsData === null || cmsData === void 0 ? void 0 : cmsData.fnBodyLabel);
        return fnHardStopText;
    }
    return hardstopText === null || hardstopText === void 0 ? void 0 : hardstopText.replace('[[tollFreeNum]]', tollFreeNumber);
}
exports.getHardStopText = getHardStopText;
function getUrlParameter(pageURL, param) {
    var _a, _b;
    if (((_a = pageURL === null || pageURL === void 0 ? void 0 : pageURL.split('?')[1]) === null || _a === void 0 ? void 0 : _a.split('&').length) > 0) {
        var urlVariables = (_b = pageURL === null || pageURL === void 0 ? void 0 : pageURL.split('?')[1]) === null || _b === void 0 ? void 0 : _b.split('&');
        for (var _i = 0, urlVariables_1 = urlVariables; _i < urlVariables_1.length; _i++) {
            var v = urlVariables_1[_i];
            var paramVariables = v === null || v === void 0 ? void 0 : v.split('=');
            if (paramVariables[0] === param) {
                return paramVariables[1];
            }
        }
    }
    return null;
}
exports.getUrlParameter = getUrlParameter;
function checkStatusCodeFromSession() {
    var checkStatusCode = sessionStorage.getItem('statusCode');
    if (checkStatusCode) {
        try {
            return JSON.parse(checkStatusCode);
        }
        catch (e) {
            return null;
        }
    }
    return null;
}
exports.checkStatusCodeFromSession = checkStatusCodeFromSession;
function getCurrentURL(extn) {
    var windowLocationHref = '';
    if (typeof window !== 'undefined') {
        windowLocationHref = window.location.href + (extn || '');
    }
    return windowLocationHref;
}
exports.getCurrentURL = getCurrentURL;
function isACPFlowWithBroadBand() {
    var acpFlagVal = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isACPFlow');
    return !!(acpFlagVal && acpFlagVal.isACPFlow && Utils.IsBroadbandInCart());
}
exports.isACPFlowWithBroadBand = isACPFlowWithBroadBand;
function isACPAccessPromoAvailable() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    if ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.length) {
        (_c = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _c === void 0 ? void 0 : _c.promotions.forEach(function (promo) {
            if (promo === null || promo === void 0 ? void 0 : promo.isAccessPromo) {
                return true;
            }
        });
    }
    return false;
}
exports.isACPAccessPromoAvailable = isACPAccessPromoAvailable;
function isDealerOffersAvailable() {
    var _a, _b;
    var payload = Utils.getCartResp();
    if ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.partnerInfo) === null || _b === void 0 ? void 0 : _b.dealerCode) {
        return true;
    }
    return false;
}
exports.isDealerOffersAvailable = isDealerOffersAvailable;
function getDueMonthlyValue() {
    var _a;
    var payload = Utils.getCartResp();
    return Number((_a = payload === null || payload === void 0 ? void 0 : payload.orderPriceInfo) === null || _a === void 0 ? void 0 : _a.dueMonthly);
}
exports.getDueMonthlyValue = getDueMonthlyValue;
function cartACPEligibility() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    var acpEligibleVal = '';
    if ((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.length) {
        (_c = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _c === void 0 ? void 0 : _c.promotions.forEach(function (promo) {
            var _a, _b, _c;
            if (((_a = promo === null || promo === void 0 ? void 0 : promo.acpEligibility) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'tribal' ||
                ((_b = promo === null || promo === void 0 ? void 0 : promo.acpEligibility) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'non_tribal') {
                acpEligibleVal = (_c = promo === null || promo === void 0 ? void 0 : promo.acpEligibility) === null || _c === void 0 ? void 0 : _c.toLowerCase();
            }
        });
    }
    return acpEligibleVal;
}
exports.cartACPEligibility = cartACPEligibility;
function getRetailOfferPortinData() {
    var _a, _b, _c, _d;
    var payload = Utils.getCartResp();
    var retailerPortinData = {
        dealerCode: '',
        dealerPortinEligible: false,
    };
    var isPartnerInfoAvailable = !!((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.partnerInfo) === null || _b === void 0 ? void 0 : _b.dealerCode);
    if (((_d = (_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c.promotions) === null || _d === void 0 ? void 0 : _d.length) > 0) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            var _a, _b, _c;
            if (((promo === null || promo === void 0 ? void 0 : promo._portIn) && (promo === null || promo === void 0 ? void 0 : promo._dealerPromotion) && isPartnerInfoAvailable) ||
                (!(promo === null || promo === void 0 ? void 0 : promo._portIn) && (promo === null || promo === void 0 ? void 0 : promo._dealerPromotion) && isPartnerInfoAvailable &&
                    ((_a = promo === null || promo === void 0 ? void 0 : promo.promotionType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'MANUALBILLCREDIT')) {
                retailerPortinData.dealerCode = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.partnerInfo) === null || _c === void 0 ? void 0 : _c.dealerCode;
                retailerPortinData.dealerPortinEligible = true;
            }
        });
    }
    return retailerPortinData;
}
exports.getRetailOfferPortinData = getRetailOfferPortinData;
function isNewWLSFlow() {
    var orderSubType = Utils.getOrderSubType();
    var lobList = Utils.getLobList();
    return !!(lobList.indexOf(CheckoutConstants_1.LOBNames.LOB_WIRELESS) > -1
        && ((orderSubType === null || orderSubType === void 0 ? void 0 : orderSubType.toUpperCase()) === CheckoutConstants_1.FlowType.NEW_WIRELESS ||
            (orderSubType === null || orderSubType === void 0 ? void 0 : orderSubType.toUpperCase()) === CheckoutConstants_1.FlowType.NEW_WIRELESS_NEW_HBOMAX ||
            (orderSubType === null || orderSubType === void 0 ? void 0 : orderSubType.toUpperCase()) === CheckoutConstants_1.FlowType.NEW_WIRELESS_ACTIVATION));
}
exports.isNewWLSFlow = isNewWLSFlow;
function isSMBNewWLSFlow() {
    if (!!Utils.isValidSMBCustomer() && !!isNewWLSFlow()) {
        return true;
    }
    return false;
}
exports.isSMBNewWLSFlow = isSMBNewWLSFlow;
function isBillPrefPanelInProgress() {
    var billPrefPanelStatus = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'isBillPrefPanelInProgress');
    return !!(billPrefPanelStatus && billPrefPanelStatus.isBillPrefPanelInProgress);
}
exports.isBillPrefPanelInProgress = isBillPrefPanelInProgress;
function IsNewWirelessInCart() {
    var orderSubType = Utils.getOrderSubType();
    var lobList = Utils.getLobList();
    return !!(lobList.indexOf(CheckoutConstants_1.LOBNames.LOB_WIRELESS) > -1
        && orderSubType && orderSubType.toUpperCase().indexOf('NEW_WIRELESS') > -1);
}
exports.IsNewWirelessInCart = IsNewWirelessInCart;
function isBillEstimatorApplicable() {
    var _a, _b, _c;
    var payload = Utils.getCartResp();
    var isCaasCustomer = false;
    var isBsseWireless = Utils.isBsseWirelessFlow();
    (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.forEach(function (promo) {
        if ((promo === null || promo === void 0 ? void 0 : promo._dealerPromotion) && (promo === null || promo === void 0 ? void 0 : promo.promotionType.toUpperCase()) !== 'REWARD') {
            isCaasCustomer = true;
        }
    });
    if (payload && payload.enableBillEstimatorComponent && !((_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c.isTitanBan)
        && !Utils.isValidSMBCustomer() && !isCaasCustomer && !isBsseWireless) {
        return true;
    }
    return false;
}
exports.isBillEstimatorApplicable = isBillEstimatorApplicable;
function isLinePlanSkuAvailable(losgId) {
    var _a, _b, _c;
    var isSkuAvailable = false;
    var payload = Utils.getCartResp();
    // tslint:disable-next-line:no-any
    var checkoutCMS = cms_integration_1.CMS.get(new DealerOffers_cms_1.DealerOffersCMS(), 'cartcheckout').content;
    // tslint:disable-next-line:no-any
    var applicablePlanSkus = (_a = checkoutCMS === null || checkoutCMS === void 0 ? void 0 : checkoutCMS.dealerOffersLnpContent) === null || _a === void 0 ? void 0 : _a.applicablePlanSkus;
    // to be removed after changes from catalog team
    var tempPlanSkus = ['sku11160233', 'sku10060297', 'sku10060302', 'sku10060281', 'sku11160234',
        'sku11160235', 'sku11160236', 'sku11160237', 'sku11160250', 'sku10060303', 'sku10060304', 'sku10060305',
        'sku10060306', 'sku10060298', 'sku10060299', 'sku10060300', 'sku10060301', 'sku11590222', 'sku11590223',
        'sku11590224', 'sku11590225', 'sku11590226', 'sku11590227', 'sku11590228', 'sku11590229', 'sku11590230', 'sku11590231',
        'sku11590232', 'sku11590233', 'sku11590234', 'sku11590235', 'sku11590236', 'sku11590237',
    ];
    applicablePlanSkus = applicablePlanSkus ? applicablePlanSkus === null || applicablePlanSkus === void 0 ? void 0 : applicablePlanSkus.concat(tempPlanSkus) : tempPlanSkus;
    if ((_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs) {
        var losgObject = Object.values(payload.wirelessCart.losgs).
            filter(function (losg) { return (losg === null || losg === void 0 ? void 0 : losg.id) === losgId; });
        if (losgObject && losgObject.length > 0) {
            Object.values((_c = losgObject === null || losgObject === void 0 ? void 0 : losgObject[0]) === null || _c === void 0 ? void 0 : _c.lineItems).forEach(function (lineItem) {
                if ((applicablePlanSkus === null || applicablePlanSkus === void 0 ? void 0 : applicablePlanSkus.some(function (sku) { return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productSKU) === sku; }))) {
                    isSkuAvailable = true;
                }
            });
        }
    }
    return !!(isSkuAvailable);
}
exports.isLinePlanSkuAvailable = isLinePlanSkuAvailable;
function getDealersOfferContent(dealerCode) {
    var _a;
    // tslint:disable-next-line:no-any
    var checkoutCMS = cms_integration_1.CMS.get(new DealerOffers_cms_1.DealerOffersCMS(), 'cartcheckout').content;
    // tslint:disable-next-line:no-any
    var dealerOffersCMS = (_a = checkoutCMS === null || checkoutCMS === void 0 ? void 0 : checkoutCMS.dealerOffersLnpContent) === null || _a === void 0 ? void 0 : _a.offers;
    var portInOffer;
    var withoutPortInOffer;
    if (dealerOffersCMS) {
        // tslint:disable-next-line:no-any
        dealerOffersCMS === null || dealerOffersCMS === void 0 ? void 0 : dealerOffersCMS.forEach(function (offer, index) {
            if (dealerOffersCMS[index] && dealerOffersCMS[index].dealercode === dealerCode) {
                portInOffer = offer === null || offer === void 0 ? void 0 : offer.portInOffer;
                withoutPortInOffer = offer === null || offer === void 0 ? void 0 : offer.withoutPortInOffer;
            }
        });
    }
    return { portInOffer: portInOffer, withoutPortInOffer: withoutPortInOffer };
}
exports.getDealersOfferContent = getDealersOfferContent;
exports.docComplete = function (handleDocumentComplete) {
    if (process && typeof window && document) {
        document.removeEventListener('readystatechange', handleDocumentComplete);
        if (document.readyState === 'interactive') {
            document.addEventListener('readystatechange', handleDocumentComplete, false);
        }
        else {
            setTimeout(handleDocumentComplete, 2);
        }
    }
};
exports.getB2BadditionalDetails = function (type) {
    var b2bDetails = Utils.getB2bDetails();
    // DOCUPLOAD_REJECTION_COUNT
    var docUploadCount;
    if (type && b2bDetails && b2bDetails.additionalDetails && b2bDetails.additionalDetails.length > 0) {
        // tslint:disable-next-line:no-any
        b2bDetails.additionalDetails.forEach(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.code) === 'DOCUPLOAD_REJECTION_COUNT') {
                docUploadCount = item === null || item === void 0 ? void 0 : item.value;
            }
        });
    }
    return docUploadCount;
};
exports.mapB2bPoeDetails = function () {
    var poeDetails = Utils.getPoeDetails();
    var b2bDetails = Utils.getB2bDetails();
    if (b2bDetails && b2bDetails.FAN) {
        var mapObj = {
            fan: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.FAN) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.fan),
            verificationId: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.IRUVerificationID) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.verificationId),
            FANBusinessName: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.FANBusinessName) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.FANBusinessName),
            uploadPoeUrl: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.IRUProofOfEligibilityURL) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.uploadPoeUrl),
            customerContractSubType: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.customerContractSubType) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.customerContractSubType),
            verificationStatus: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.verificationStatus) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.verificationStatus) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.currentStep),
            currentStep: (b2bDetails === null || b2bDetails === void 0 ? void 0 : b2bDetails.verificationStatus) || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.currentStep),
            docUploadCount: exports.getB2BadditionalDetails('DOCUPLOAD_REJECTION_COUNT') || (poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.docUploadCount),
            job: poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.job,
            segment: poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.segment,
            branchType: poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.branchType,
            militaryStatus: '',
            organization: poeDetails === null || poeDetails === void 0 ? void 0 : poeDetails.organization,
        };
        return mapObj;
    }
    else {
        return null;
    }
};
exports.convertToCamelCase = function (str) {
    var _a, _b;
    return ((_a = str === null || str === void 0 ? void 0 : str.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = str === null || str === void 0 ? void 0 : str.slice(1)) === null || _b === void 0 ? void 0 : _b.toLowerCase());
};
// tslint:disable-next-line:no-any
exports.getReasonCode = function (sessionErrorData) {
    var _a, _b, _c;
    if (sessionErrorData === null || sessionErrorData === void 0 ? void 0 : sessionErrorData.data) {
        var errorCode = JSON.parse(sessionErrorData.data);
        if ((_b = (_a = errorCode === null || errorCode === void 0 ? void 0 : errorCode.trace) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errorId) {
            return errorCode.trace.error.errorId;
        }
        else if ((_c = errorCode === null || errorCode === void 0 ? void 0 : errorCode.error) === null || _c === void 0 ? void 0 : _c.errorId) {
            return errorCode.error.errorId;
        }
        else {
            return sessionErrorData === null || sessionErrorData === void 0 ? void 0 : sessionErrorData.reasonCode;
        }
    }
    else {
        return sessionErrorData === null || sessionErrorData === void 0 ? void 0 : sessionErrorData.reasonCode;
    }
};
//# sourceMappingURL=CommonUtilFuntions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/CommonUtilFuntions.js
// module id = 114
// module chunks = 8